import { handleRoute } from "../https";

export const configLifeInsurance = async ({
  companyId,
  id: benefitModelId,
  ...rest
}) => {
  const res = handleRoute({
    method: "put",
    path: `/v1/companies/${companyId}/benefits/${benefitModelId}`,
    payload: { id: benefitModelId, companyId, ...rest },
  });
  return res;
};
